import { Hash } from "lucide-react";
import { useEffect, useState } from "react";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

import CampoCliente, { CAMPO } from "./CampoCliente";

/**
 * Editar uma comanda: número, observação e cliente. Abrir comanda nova é a
 * NovaComandaDialog (26/10/2026: um botão só para abrir e pesar). Cliente e
 * observação são opcionais. Enter salva.
 */
export default function AbrirComandaDialog({ open, onClose, inicial = null, sugestaoNumero = "", onConfirmar }) {
  const [cliente, setCliente] = useState({ nome: "", clienteId: null, telefone: null });
  const [numero, setNumero] = useState("");
  const [observacao, setObservacao] = useState("");
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (!open) return;
    setCliente({ nome: inicial?.cliente_nome || "", clienteId: inicial?.cliente_id || null, telefone: inicial?.cliente_telefone || null });
    setNumero(String(inicial ? inicial.numero || "" : sugestaoNumero || "")); setObservacao(inicial?.observacao || "");
  }, [open, inicial]); // eslint-disable-line react-hooks/exhaustive-deps -- a sugestão vale ao abrir, não a cada 10 s

  // Só dígitos, de 1 a 9999 (o backend confere de novo e recusa número de comanda já aberta)
  const numeroValido = /^\d{1,4}$/.test(numero.trim()) && Number(numero) >= 1;
  const confirmar = async () => {
    if (!numeroValido || enviando) return;
    setEnviando(true);
    try {
      await onConfirmar({ numero: Number(numero), cliente_nome: cliente.nome.trim() || null, cliente_id: cliente.clienteId, cliente_telefone: cliente.telefone, observacao: observacao.trim() || null });
      onClose();
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md" data-e2e="comanda-abrir"
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); confirmar(); } }}>
        <DialogHeader>
          <DialogTitle>{inicial ? "Editar comanda" : "Nova comanda"}</DialogTitle>
          <DialogDescription>O nome é opcional: dá para abrir sem cliente e preencher depois.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="block text-xs font-medium mb-1">Nº da comanda</label>
            <div className="relative">
              <Hash className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <input value={numero} onChange={(e) => setNumero(e.target.value.replace(/\D/g, "").slice(0, 4))} onFocus={(e) => e.target.select()} autoFocus
                placeholder="1" inputMode="numeric" data-e2e="comanda-numero" className={`${CAMPO} pl-9 text-base font-bold tabular-nums`} />
            </div>
            <p className="text-[11px] text-muted-foreground mt-1">{inicial ? "Troque se a comanda física for outra." : "Já vem com o próximo número livre; digite para trocar."}</p>
          </div>
          <div>
            <label className="block text-xs font-medium mb-1">Observação</label>
            <input value={observacao} onChange={(e) => setObservacao(e.target.value)} maxLength={200} placeholder="Ex.: mesa da varanda" className={CAMPO} />
          </div>
          <CampoCliente open={open} valor={cliente} onChange={setCliente} />
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" onClick={onClose} className="h-10 px-4 rounded-lg border text-sm font-semibold hover:bg-muted">Voltar</button>
            <button type="button" onClick={confirmar} disabled={enviando || !numeroValido} data-e2e="comanda-abrir-confirmar"
              className="h-10 px-5 rounded-lg bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 disabled:opacity-50">
              {enviando ? "Salvando…" : inicial ? "Salvar" : "Abrir comanda"}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
